export const storageKeys = {
  ACCESS_TOKEN: 'app:accessToken',
  REFRESH_TOKEN: 'app:refreshToken',
  REDIRECT_AFTER_AUTH: 'redirectToAfterLogin',
  THEME_MODE: 'app:theme',
};
